/**
 * The one place the settings forms state what a day threshold means. Every
 * threshold on these forms counts business days, so each form that has one
 * renders this above its fields rather than repeating the unit per field.
 */
export function BusinessDaysNote() {
  return (
    <p className="text-xs text-muted-foreground">
      Day thresholds below count business days (Monday to Friday) in your
      organization&apos;s timezone. Weekends never count.
    </p>
  );
}
